// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={153}
    height={152}
    viewBox="0 0 153 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M39.0656 112.319L34.7548 40.1546C34.7411 39.9261 34.7745 39.6973 34.8528 39.4822C34.9311 39.2671 35.0528 39.0701 35.2103 38.9034C35.3678 38.7368 35.5579 38.6038 35.7688 38.5128C35.9798 38.4219 36.2072 38.3747 36.4372 38.3743L103.108 38.2457C103.539 38.2449 103.955 38.4083 104.269 38.7024C104.583 38.9965 104.772 39.3991 104.798 39.8276L109.12 112.184L39.0656 112.319Z"
      fill="#C9C8D0"
    />
    <path
      d="M38.9287 112.46L38.9206 112.326L34.6099 40.1616C34.5951 39.9138 34.6313 39.6657 34.7163 39.4324C34.8013 39.1991 34.9332 38.9855 35.104 38.8048C35.2749 38.624 35.481 38.4798 35.7097 38.3811C35.9385 38.2824 36.1852 38.2313 36.4345 38.2308L103.105 38.1024C103.573 38.1017 104.024 38.279 104.364 38.598C104.705 38.9169 104.911 39.3534 104.939 39.8181L109.27 112.324L109.118 112.324L38.9287 112.46ZM103.697 38.5022C103.51 38.4254 103.309 38.3862 103.106 38.3868L36.4352 38.5152C36.2247 38.5156 36.0166 38.5588 35.8235 38.6421C35.6303 38.7254 35.4564 38.8471 35.3122 38.9997C35.168 39.1523 35.0567 39.3326 34.985 39.5295C34.9133 39.7265 34.8828 39.9359 34.8953 40.145L39.1979 112.175L108.966 112.04L104.653 39.8346C104.636 39.5456 104.537 39.2672 104.368 39.0316C104.198 38.7959 103.966 38.6124 103.697 38.5022Z"
      fill="black"
    />
    <path
      d="M37.9084 50.783L40.9984 107.556L48.2512 90.041L41.7456 50.7714L37.9084 50.783Z"
      fill="#7F7E84"
    />
    <mask
      id="mask0_2056_70083"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={34}
      y={38}
      width={76}
      height={75}
    >
      <path
        d="M39.0553 112.334L34.769 40.1608C34.7555 39.9323 34.7889 39.7035 34.8673 39.4883C34.9457 39.2731 35.0674 39.0761 35.2249 38.9093C35.3825 38.7426 35.5726 38.6095 35.7835 38.5185C35.9945 38.4274 36.2219 38.3802 36.4518 38.3796L103.114 38.2291C103.545 38.2282 103.96 38.3914 104.275 38.6855C104.589 38.9796 104.778 39.3821 104.803 39.8107L109.101 112.176L39.0553 112.334Z"
        fill="#C9C8D0"
      />
    </mask>
    <g mask="url(#mask0_2056_70083)" />
    <path
      d="M43.4682 92.7537L40.971 49.3601C40.9609 49.1853 40.9868 49.0102 41.047 48.8457C41.1072 48.6812 41.2005 48.5306 41.3212 48.4031C41.4419 48.2757 41.5874 48.1741 41.7489 48.1046C41.9103 48.035 42.0844 47.999 42.2604 47.9986L109.722 47.8686C110.053 47.8679 110.372 47.9935 110.613 48.2195C110.854 48.4455 110.999 48.7547 111.018 49.0836L113.523 92.6186L43.4682 92.7537Z"
      fill="white"
    />
    <mask
      id="mask1_2056_70083"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={40}
      y={47}
      width={74}
      height={46}
    >
      <path
        d="M43.462 92.7668L40.9792 49.3662C40.9692 49.1913 40.9951 49.0162 41.0554 48.8517C41.1156 48.6871 41.209 48.5364 41.3297 48.4089C41.4504 48.2814 41.5959 48.1798 41.7574 48.1102C41.9189 48.0405 42.093 48.0044 42.2689 48.004L109.724 47.852C110.055 47.8512 110.374 47.9767 110.615 48.2027C110.856 48.4286 111 48.7378 111.019 49.0668L113.51 92.6089L43.462 92.7668Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_2056_70083)">
      <path
        d="M41.0515 52.1072L111.105 51.9458L110.794 46.3011L40.8701 46.9772L41.0515 52.1072Z"
        fill="#E4E3E7"
      />
    </g>
    <path
      d="M45.685 90.3335L44.3818 65.3989L56.7077 65.4064L58.1381 90.3238L45.685 90.3335Z"
      fill="#E4E3E7"
    />
    <path
      d="M44.0881 61.4162L44.0086 59.4646L56.5189 59.3982L56.5473 61.4065L44.0881 61.4162Z"
      fill="#E4E3E7"
    />
    <path
      d="M52.2467 63.0915L44.2812 63.0938L44.2809 63.3219L52.2464 63.3197L52.2467 63.0915Z"
      fill="#E4E3E7"
    />
    <path
      d="M56.7379 63.0959L53.7285 63.0967L53.7281 63.3221L56.7376 63.3212L56.7379 63.0959Z"
      fill="#E4E3E7"
    />
    <path
      d="M56.63 62.108L49.2832 62.1504L49.2841 62.3673L56.6309 62.3249L56.63 62.108Z"
      fill="#E4E3E7"
    />
    <path
      d="M48.0596 62.1459L44.1172 62.1689L44.1181 62.3887L48.0605 62.3657L48.0596 62.1459Z"
      fill="#E4E3E7"
    />
    <path
      d="M60.1203 90.493L60.1154 90.3858L58.66 59.0743L58.7774 59.0739L104.599 58.8906L106.119 90.1675L106.001 90.1682L60.1203 90.493ZM58.8952 59.2972L60.3349 90.2679L105.883 89.9451L104.385 59.1155L58.8952 59.2972Z"
      fill="#E4E3E7"
    />
    <path
      d="M106.57 58.8606L109.447 58.8127L111 90.252L108.156 90.2206L106.57 58.8606Z"
      fill="#E4E3E7"
    />
    <path
      d="M46.6514 78.0024L46.5948 76.6135L55.4984 76.5661L55.5187 77.9955L46.6514 78.0024Z"
      fill="white"
    />
    <path
      d="M47.1543 88.1207L47.0887 86.5092L48.8379 86.4995L48.9292 88.1207L47.1543 88.1207ZM47.3227 86.7317L47.37 87.897L48.6917 87.8969L48.6255 86.7247L47.3227 86.7317Z"
      fill="white"
    />
    <path
      d="M46.932 84.9026L46.8664 83.2911L48.6532 83.2813L48.7442 84.9026L46.932 84.9026ZM47.1004 83.5135L47.1477 84.6789L48.5068 84.6787L48.4409 83.5064L47.1004 83.5135Z"
      fill="white"
    />
    <path
      d="M55.6966 79.9967L49.5625 80.0322L49.5634 80.2501L55.6975 80.2146L55.6966 79.9967Z"
      fill="white"
    />
    <path
      d="M55.6777 80.8206L49.5996 80.8223L49.5992 81.0494L55.6773 81.0477L55.6777 80.8206Z"
      fill="white"
    />
    <path
      d="M55.8645 83.5494L49.7305 83.585L49.7314 83.8029L55.8655 83.7673L55.8645 83.5494Z"
      fill="white"
    />
    <path
      d="M55.8537 84.3772L49.7754 84.3789L49.775 84.606L55.8533 84.6043L55.8537 84.3772Z"
      fill="white"
    />
    <path
      d="M56.1106 86.7867L49.9766 86.8223L49.9775 87.0402L56.1116 87.0046L56.1106 86.7867Z"
      fill="#FFE9A4"
    />
    <path
      d="M56.0957 87.6126L50.0176 87.6143L50.0172 87.8414L56.0953 87.8397L56.0957 87.6126Z"
      fill="#FFE9A4"
    />
    <path
      d="M46.6662 81.4706L46.6005 79.8592L48.4553 79.8489L48.5465 81.4708L46.6662 81.4706ZM46.8346 80.0816L46.8819 81.2468L48.3091 81.2469L48.2429 80.074L46.8346 80.0816Z"
      fill="white"
    />
    <path
      d="M50.7786 72.1429C49.7728 72.1376 48.9179 72.7916 48.5189 73.7383C48.5259 73.7459 48.5329 73.7535 48.54 73.7611C48.8338 74.0996 49.1955 74.3729 49.602 74.5633C50.0085 74.7538 50.4508 74.8572 50.9003 74.8669C51.3324 74.8673 51.7593 74.7701 52.1489 74.5828C52.5385 74.3955 52.8808 74.1228 53.15 73.7852C53.1568 73.7774 53.1634 73.7694 53.1701 73.7615C52.6855 72.8108 51.7841 72.1482 50.7786 72.1429ZM50.6463 69.1813C50.0559 69.1782 49.6178 69.7161 49.6474 70.379C49.677 71.0419 50.1634 71.5847 50.7539 71.5877C51.333 71.5908 51.7695 71.0528 51.7399 70.3899C51.7103 69.7271 51.2255 69.1843 50.6464 69.1813"
      fill="white"
    />
    <path
      d="M48.516 73.7373C47.8567 73.0059 47.4758 72.0667 47.4395 71.0829C47.3468 69.0068 48.7475 67.3247 50.5612 67.3341C52.3684 67.3436 53.9137 69.0411 54.0064 71.1172C54.0676 72.0709 53.7684 73.0138 53.1676 73.7606C53.1609 73.7685 53.1543 73.7764 53.1475 73.7843C52.8783 74.1219 52.536 74.3946 52.1463 74.5819C51.7567 74.7693 51.3298 74.8664 50.8977 74.8661C50.4481 74.8563 50.0058 74.7529 49.5992 74.5625C49.1927 74.372 48.8309 74.0987 48.5371 73.7602C48.53 73.7526 48.523 73.745 48.516 73.7373ZM50.552 67.128C48.6378 67.118 47.1615 68.8907 47.2594 71.082C47.2983 72.1307 47.7078 73.1309 48.4155 73.9062C48.7261 74.2628 49.1081 74.5506 49.5371 74.7514C49.966 74.9522 50.4326 75.0614 50.9069 75.0722C51.363 75.0724 51.8135 74.9699 52.2248 74.7725C52.6361 74.575 52.9976 74.2875 53.2823 73.9317C53.9295 73.1405 54.2525 72.1352 54.1865 71.1182C54.0886 68.9269 52.4582 67.138 50.552 67.128Z"
      fill="white"
    />
    <path
      d="M102.643 63.2218C102.784 63.2811 102.906 63.378 102.995 63.5019C103.084 63.6258 103.137 63.7719 103.148 63.924L103.3 66.0273C103.308 66.132 103.295 66.2373 103.262 66.3371C103.229 66.4369 103.176 66.529 103.106 66.608C103.041 66.6822 102.962 66.7425 102.872 66.7854C102.783 66.8283 102.686 66.8528 102.588 66.8577C102.475 66.8636 102.362 66.8443 102.258 66.8014C102.117 66.7421 101.995 66.6451 101.906 66.5212C101.817 66.3973 101.764 66.2513 101.753 66.0991L101.602 63.9958C101.593 63.8911 101.606 63.7858 101.639 63.686C101.672 63.5862 101.725 63.4941 101.795 63.4151C101.86 63.3409 101.94 63.2806 102.029 63.2377C102.118 63.1949 102.215 63.1703 102.313 63.1654C102.426 63.1595 102.539 63.1788 102.643 63.2218ZM102.71 63.0602C102.562 62.9989 102.4 62.977 102.24 62.9966C102.08 63.0163 101.929 63.0769 101.799 63.1724C101.67 63.268 101.568 63.3952 101.502 63.5418C101.437 63.6884 101.411 63.8493 101.427 64.0087L101.578 66.112C101.591 66.2965 101.655 66.4738 101.764 66.624C101.872 66.7743 102.02 66.8916 102.191 66.963C102.339 67.0243 102.501 67.0462 102.661 67.0265C102.821 67.0068 102.973 66.9462 103.102 66.8507C103.231 66.7551 103.334 66.6278 103.399 66.4813C103.464 66.3347 103.49 66.1738 103.474 66.0144L103.323 63.9111C103.31 63.7266 103.246 63.5493 103.138 63.3991C103.029 63.2489 102.882 63.1315 102.71 63.0602Z"
      fill="#E0DDD5"
    />
    <path
      d="M102.112 60.3549C101.987 60.3626 101.864 60.3952 101.752 60.4509C101.639 60.5066 101.539 60.5842 101.457 60.6791C101.375 60.774 101.313 60.8844 101.275 61.0036C101.236 61.1227 101.222 61.2483 101.234 61.3729C101.25 61.6282 101.365 61.867 101.555 62.0388C101.745 62.2106 101.995 62.3018 102.252 62.2931C102.377 62.2855 102.5 62.2529 102.612 62.1972C102.725 62.1415 102.825 62.0639 102.907 61.969C102.989 61.8741 103.051 61.7637 103.089 61.6446C103.128 61.5254 103.142 61.3998 103.13 61.2753C103.114 61.0199 102.999 60.7811 102.809 60.6093C102.619 60.4375 102.369 60.3463 102.112 60.3549ZM102.756 61.4261L102.296 61.4497L102.33 61.9183L102.121 61.9291L102.087 61.4605L101.627 61.4841L101.612 61.2692L102.071 61.2456L102.038 60.777L102.247 60.7662L102.281 61.2348L102.74 61.2112L102.756 61.4261Z"
      fill="#E4E3E7"
    />
    <path
      d="M107.873 63.0735C108.238 63.2231 108.657 63.049 108.808 62.6847C108.959 62.3204 108.785 61.9038 108.419 61.7542C108.054 61.6046 107.635 61.7787 107.485 62.143C107.334 62.5073 107.508 62.9239 107.873 63.0735Z"
      fill="white"
    />
    <path
      d="M108.831 60.6854L107.398 60.7119L107.402 60.894L108.834 60.8675L108.831 60.6854Z"
      fill="white"
    />
    <path
      d="M107.392 60.3795L107.388 60.1956L108.82 60.1681L108.823 60.3518L107.392 60.3795Z"
      fill="white"
    />
    <path
      d="M108.811 59.6522L107.379 59.6787L107.382 59.8608L108.814 59.8343L108.811 59.6522Z"
      fill="white"
    />
    <path
      d="M43.3331 92.8961L43.3253 92.7618L40.8279 49.3681C40.8168 49.174 40.8455 48.9796 40.9124 48.7969C40.9793 48.6142 41.0829 48.447 41.2169 48.3055C41.3509 48.1641 41.5125 48.0513 41.6918 47.974C41.8711 47.8968 42.0643 47.8568 42.2597 47.8564L109.722 47.7263C110.089 47.7257 110.443 47.8652 110.71 48.1161C110.978 48.367 111.139 48.7103 111.16 49.0754L113.674 92.7606L113.523 92.7608L43.3331 92.8961ZM110.163 48.0966C110.023 48.0394 109.873 48.0102 109.722 48.0107L42.2604 48.1408C42.1039 48.1411 41.949 48.1732 41.8054 48.235C41.6617 48.2969 41.5322 48.3873 41.4248 48.5006C41.3175 48.614 41.2345 48.7479 41.1809 48.8943C41.1273 49.0407 41.1042 49.1964 41.1131 49.3519L43.6027 92.6113L113.371 92.4767L110.875 49.0916C110.862 48.8759 110.789 48.668 110.663 48.492C110.537 48.3159 110.363 48.1789 110.163 48.0966Z"
      fill="#29292F"
    />
    <path
      d="M43.5842 50.6812C43.8754 50.523 43.9532 50.1062 43.7578 49.7503C43.5625 49.3943 43.1681 49.234 42.8769 49.3922C42.5857 49.5505 42.5079 49.9673 42.7033 50.3232C42.8986 50.6791 43.293 50.8394 43.5842 50.6812Z"
      fill="#FFE9A4"
    />
    <path
      d="M45.2604 49.681C45.2992 49.6971 45.336 49.7178 45.37 49.7425C45.485 49.8254 45.5694 49.9438 45.61 50.0792C45.6507 50.2146 45.6454 50.3596 45.5949 50.4916C45.5761 50.5321 45.5494 50.5684 45.5163 50.5984C45.4832 50.6284 45.4444 50.6515 45.4022 50.6663C45.36 50.6811 45.3152 50.6874 45.2705 50.6848C45.2258 50.6821 45.1821 50.6706 45.1419 50.6508C45.1031 50.6347 45.0663 50.614 45.0323 50.5892C44.9173 50.5063 44.833 50.388 44.7923 50.2526C44.7517 50.1171 44.7571 49.9722 44.8076 49.8401C44.8264 49.7997 44.8531 49.7634 44.8862 49.7334C44.9192 49.7034 44.958 49.6803 45.0002 49.6654C45.0424 49.6506 45.0872 49.6443 45.1319 49.647C45.1766 49.6497 45.2203 49.6612 45.2604 49.681ZM45.3331 49.5053C45.2706 49.4762 45.2031 49.4596 45.1342 49.4566C45.0654 49.4535 44.9966 49.464 44.9318 49.4874C44.8671 49.5108 44.8076 49.5467 44.7568 49.593C44.706 49.6393 44.6648 49.6951 44.6357 49.7573C44.5653 49.9295 44.555 50.1203 44.6066 50.2991C44.6582 50.4779 44.7687 50.6342 44.9202 50.743C44.9664 50.7766 45.0165 50.8046 45.0693 50.8265C45.1317 50.8556 45.1993 50.8721 45.2681 50.8752C45.337 50.8783 45.4058 50.8678 45.4705 50.8444C45.5353 50.821 45.5948 50.7851 45.6456 50.7388C45.6964 50.6925 45.7376 50.6367 45.7667 50.5745C45.8371 50.4023 45.8474 50.2115 45.7958 50.0327C45.7442 49.8539 45.6337 49.6976 45.4821 49.5888C45.4359 49.5552 45.3859 49.5271 45.3331 49.5053Z"
      fill="#FFE9A4"
    />
    <path
      d="M85.4509 63.069L87.4666 58.1955C87.5313 58.0379 87.5558 57.8668 87.5381 57.6975C87.5203 57.5282 87.4608 57.3658 87.3648 57.2249C87.2688 57.0839 87.1394 56.9687 86.9879 56.8896C86.8364 56.8104 86.6677 56.7697 86.4966 56.7711L63.4642 56.9167C63.0237 56.919 62.5937 57.0508 62.2283 57.2955C61.8629 57.5402 61.5783 57.887 61.4103 58.2922L39.0651 112.317L109.327 112.267L129.05 64.5813C129.112 64.4312 129.135 64.2683 129.119 64.107C129.102 63.9457 129.046 63.7909 128.955 63.6562C128.865 63.5215 128.742 63.4111 128.598 63.3346C128.455 63.2581 128.294 63.218 128.131 63.2177L85.4509 63.069Z"
      fill="#C9C8D0"
    />
    <path
      d="M38.8514 112.46L61.2779 58.238C61.456 57.8065 61.7586 57.4372 62.1475 57.1767C62.5364 56.9163 62.9941 56.7763 63.4629 56.7745L86.4953 56.6287C86.6899 56.6273 86.8819 56.6736 87.0542 56.7638C87.2265 56.8539 87.3738 56.985 87.4829 57.1454C87.5921 57.3058 87.6597 57.4905 87.6799 57.6832C87.7 57.8758 87.6721 58.0704 87.5984 58.2497L85.6636 62.9275L128.132 63.0756C128.318 63.076 128.501 63.1219 128.666 63.2094C128.83 63.2969 128.97 63.4233 129.074 63.5774C129.178 63.7315 129.242 63.9085 129.261 64.0931C129.279 64.2776 129.252 64.4638 129.182 64.6355L109.422 112.409L109.327 112.409L38.8514 112.46ZM86.8457 56.9805C86.7352 56.9353 86.6168 56.9124 86.4973 56.9133L63.4649 57.0591C63.0524 57.0605 62.6496 57.1835 62.3073 57.4126C61.9651 57.6417 61.6988 57.9666 61.542 58.3463L39.278 112.175L109.231 112.125L128.918 64.5272C128.97 64.3987 128.99 64.2592 128.976 64.1211C128.962 63.983 128.914 63.8504 128.836 63.7351C128.758 63.6198 128.653 63.5253 128.53 63.4598C128.407 63.3944 128.27 63.36 128.131 63.3598L85.2376 63.2104L87.3342 58.1413C87.3912 58.0063 87.4132 57.8592 87.3982 57.7135C87.3831 57.5678 87.3315 57.4282 87.2481 57.3075C87.1493 57.1614 87.0093 57.0476 86.8457 56.9805Z"
      fill="black"
    />
    <path
      d="M68.0515 93.0549L97.8583 93.0187L101.905 83.2359L72.0662 83.3484L68.0515 93.0549Z"
      fill="#9B9AA2"
    />
  </svg>
);
const SvgFolderGray = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgFolderGray;
